/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { isEmpty } from 'lodash';
import { emptyPagination } from '../../../../ProductsHistory/utils/defaultData';
import exluedAggregationTypeSet from '../../../../../utils/stash/exluedAggregationTypeSet';
import getUniqArrayOfObjects from '../../../../../utils/getUniqArrayOfObjects';
import attributeAggList from '../../../../../utils/stash/attributeAggList';

const useAttribute = (state, props) => {
  const isAggregationAttribute = attributeAggList.some((agg) => agg.value === state.logType);

  const messages = [...state.messageFilter];

  const searchFilter = {
    aggregations: [],
    fields: [],
    filter: [...state.filter],
    pagination: state.pagination,
    logType: state.logType,
  };

  const filter = [];
  const fetchList = (groupFilter = []) => {
    filter.push({
      condition: 'and',
      group: [
        ...groupFilter,
      ],
    });
    if (!isEmpty(state.messageAttributeOptionAggregation) && !isEmpty(state.aggregationType)) {
      searchFilter.pagination = emptyPagination;
      searchFilter.aggregations = state.messageAttributeOptionAggregation;
    }

    const mappedFilter = getUniqArrayOfObjects([...searchFilter.filter, ...filter].flat());

    const isExtraFetch = !exluedAggregationTypeSet.has(state.aggregationType.value)
      && !exluedAggregationTypeSet.has(state.setSelectedChart.id);

    searchFilter.filter = mappedFilter.filter((sf) => sf.group.some((g) => g.field !== 'log_type'));
    props.fetchAttributeOptionAggregationList({
      ...searchFilter,
      isExtraFetch,
    });
  };

  useEffect(() => {
    const { list } = props.attribute;
    const { titleId } = state.selectedAttribute;
    const isExist = titleId && (!isEmpty(list) && !isEmpty(state.selectedAttribute)
      && !isEmpty(
        list.some((a) => a.code === titleId).options
          ? list.find((a) => a.code === titleId).options
          : [],
      ));
    if (
      state.pagination
      && !isEmpty(state.messageAttributeOptionAggregation)
      && isAggregationAttribute
      && !isExist
    ) {
      fetchList([...messages].flat());
    }
  }, [
    state.pagination,
    state.messageAttributeOptionAggregation,
  ]);
};

export default useAttribute;
